
/// <amd-module name="Build/SourceProviders/SourceProvider" />
import { Bitbucket } from "Build/SourceProviders/Bitbucket";
import { ExternalGit } from "Build/SourceProviders/ExternalGit";
import { ExternalUnknown } from "Build/SourceProviders/ExternalUnknown";
import { GitHub } from "Build/SourceProviders/GitHub";
import { GitHubEnterprise } from "Build/SourceProviders/GitHubEnterprise";
import { TfsGit } from "Build/SourceProviders/TfsGit";
import { Svn } from "Build/SourceProviders/Svn";
import { TfsVersionControl } from "Build/SourceProviders/TfsVersionControl";

import { ISourceProvider, RepositoryTypes } from "Common";

import { IVssService, Services, VssService, IVssPageContext } from "VSS/Platform/Context";

export interface ISourceProviderService extends IVssService {
    getSourceProvider(repositoryType: string): ISourceProvider | undefined;
}

export class SourceProviderService extends VssService implements ISourceProviderService {
    private _sourceProviders: { [key: string]: ISourceProvider } = {};

    public _serviceStart(pageContext: IVssPageContext): void {
        super._serviceStart(pageContext);
        const allProviders = [
            new Bitbucket(pageContext),
            new ExternalGit(pageContext),
            new GitHub(pageContext),
            new GitHubEnterprise(pageContext),
            new Svn(pageContext),
            new TfsGit(pageContext),
            new TfsVersionControl(pageContext),
            new ExternalUnknown(pageContext)
        ];

        allProviders.forEach((provider) => {
            this._sourceProviders[provider.getKey()] = provider;
        });
    }

    public getSourceProvider(repositoryType: string): ISourceProvider | undefined {
        repositoryType = repositoryType || "";
        repositoryType = repositoryType.toLocaleLowerCase();
        const provider = this._sourceProviders[repositoryType];
        if (provider) {
            return provider;
        }
        else {
            console.warn("Provider with type " + repositoryType + " is not initialized, fetching a generic external provider");
            return this._sourceProviders[RepositoryTypes.ExternalUnknown];
        }
    }
}

Services.add("ISourceProviderService", { serviceFactory: SourceProviderService });
